import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import ContactInfo from "@/components/contact/ContactInfo";
import ContactForm from "@/components/contact/ContactForm";

const SuccessScreen = () => (
  <main className="bg-white pt-32 pb-32">
    <div className="max-w-[700px] mx-auto px-6 text-center">
      <CheckCircle2 size={56} className="text-razmek-gold mx-auto" />
      <h2 className="font-serif text-4xl mt-6 text-razmek-dark">
        Gracias por contactarnos
      </h2>
      <p className="font-sans text-base text-razmek-dark/70 mt-4 leading-relaxed">
        Hemos recibido tu solicitud. Un asesor te contactará en menos de 24
        horas hábiles para confirmar la cita.
      </p>
    </div>
  </main>
);

const ContactoHero = () => (
  <section className="bg-razmek-alt py-16 lg:py-20">
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
      <div className="eyebrow">Contacto</div>
      <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05] text-razmek-dark">
        Agenda tu
        <br />
        <span className="italic text-razmek-blue">primera asesoría</span>.
      </h1>
    </div>
  </section>
);

const Contacto = () => {
  const [done, setDone] = useState(false);

  if (done) return <SuccessScreen />;

  return (
    <main className="bg-white pt-28 lg:pt-32">
      <ContactoHero />
      <section className="py-16 lg:py-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <ContactInfo />
          </div>
          <ContactForm onSuccess={() => setDone(true)} />
        </div>
      </section>
    </main>
  );
};

export default Contacto;
